import React, { useCallback, useEffect, useState } from "react";
import { Button, Labeled, required, TextField, TextInput, useNotify } from "react-admin";
import AddIcon from "@mui/icons-material/Add";
import Edit from "@mui/icons-material/Edit";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";
import { settings } from "app";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

const SportAthleteInfo = ({ studentId }) => {
  const notify = useNotify();

  const [sportAthleteAchievements, setSportAthleteAchievements] = useState(null);

  const fetchSportAthleteInfo = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getStudentSportAthleteAchievements(studentId),
        null,
        "GET",
      );
      setSportAthleteAchievements(data);
    } catch (err) {
      if (err.status === 404) {
        setSportAthleteAchievements(null);
        return;
      }
      console.error(err);
    }
  }, [studentId]);

  useEffect(() => {
    if (!studentId) return;
    fetchSportAthleteInfo();
  }, [fetchSportAthleteInfo, studentId]);

  const handleSave = async ({ sportDescription }) => {
    await dataProvider.customRequest(
      studentRequests.createStudentSportAthleteAchievements(studentId),
      { sportDescription },
      "PUT",
    );
    notify("Успешно запазване на спортни постижения", { type: "success" });
    await fetchSportAthleteInfo();
  };

  const hasData = !!sportAthleteAchievements?.sportDescription;

  return (
    <>
      <Labeled label="Спортни постижения">
        <TextField
          record={sportAthleteAchievements}
          source="sportDescription"
          emptyText="-"
        />
      </Labeled>
      <div>
        <SecuredComponent permission={permissions.canUpdateStudentSportAthleteInfo}>
          <FormModal
            titleContent={hasData ? "Редактиране на спортни постижения" : "Добавяне на спортни постижения"}
            onConfirm={handleSave}
            defaultValues={{ sportDescription: sportAthleteAchievements?.sportDescription }}
            triggerButton={
              <Button
                label={hasData ? "Редактирай спортни постижения" : "Добави спортни постижения"}
                startIcon={hasData ? <Edit /> : <AddIcon />}
                variant="contained"
              />
            }
          >
            <TextInput
              source="sportDescription"
              label="Спортни постижения"
              sx={settings.style.textAria}
              variant="outlined"
              fullWidth
              multiline
              minRows={1}
              maxRows={12}
              validate={[required()]}
            />
          </FormModal>
        </SecuredComponent>
      </div>
    </>
  );
};

export default SportAthleteInfo;
